import { evaluate, equal } from "mathjs";

export const isFormula = (str: string) => {

    const arreglo = [];

    try {
        for (var i = 1; i < 10+1; i++) {
            arreglo.push(isNaN(evaluate(str,{X:i/10})));
        }
    } catch (error) {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa una fórmula'
        }
    }
 
    const long = arreglo.filter(Boolean).length

    if (long === 0) {
        return { 
            ok: true, 
            title: 'Exito',
            msg: `${str} es una fórmula`
        }
    } else {
        return { 
            ok: false, 
            title: '¡Cuidado!',
            msg: 'No has ingresado una respuesta'
        }
    }
}

export const equalFormulas = (numberDataBase: string, numberUser: string) => {

    const arreglo = [];
    try {
        for (var i = 1; i < 20+1; i++) {
            arreglo.push(equal(evaluate(numberDataBase,{X:i/20}),evaluate(numberUser,{X:i/20})))
        }
    } catch (error) {
        return { 
            ok: true, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa una fórmula'
        }
    }

    const long = arreglo.filter(Boolean).length

    if (long === 20) {
        return { 
            ok: true, 
            title: '¡Felicitaciones!',
            msg: 'Has encontrado el número solución'
        }
    } else {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la fórmula solución'
        }
    }
}